<template>
  <v-navigation-drawer
    v-model="drawer"
    width="400"
    app
    temporary
    right
    class="wost-drawer"
  >
    <div class="navigation-head">
      <span>{{ titleForm }}</span>
    </div>

    <div class="pl-3 pt-3 pr-3" style="height: 80vh">
      <template>
        <v-row>
          <v-col cols="4">
            <v-text-field
              ref="name"
              v-model="prosecutionForm.numero_orden"
              :value="prosecutionForm.numero_orden"
              label="N° Orden"
              outlined
              @keydown="handleInputSearchByEnter"
              :rules="[
                () =>
                  !!prosecutionForm.numero_orden ||
                  'Es necesario ingresar un N° Orden',
              ]"
              hide-details="auto"
              required
            ></v-text-field>
          </v-col>
          <v-col cols="8">
            <v-autocomplete
              ref="sedes"
              :value="prosecutionForm.office_id"
              v-model="prosecutionForm.office_id"
              :items="offices"
              label="SEDES"
              outlined
              :item-text="customText"
              item-value="id"
              hide-details="auto"
              @change="handleChangeMaterial()"
              required
            ></v-autocomplete>
          </v-col>
        </v-row>

        <v-row v-if="prosecutionForm.sale != null">
          <div style="padding: 10px 13px; width: 100%">
            <v-card
              elevation="2"
              style="
                padding: 10px 15px;
                display: flex;
                justify-content: space-between;
                width: 100%;
              "
            >
              <div style="display: flex; flex-direction: column">
                <label for="" style="font-weight: 900">Paciente</label>
                <label for="">{{
                  prosecutionForm.sale.customer_fullname
                }}</label>
                <div style="display: flex">
                  <label for="">
                    {{ prosecutionForm.sale.customer_born_date }}
                  </label>
                  <label for="" style="margin-left: 10px">
                    {{
                      prosecutionForm.sale.customer_gender == "M"
                        ? "Masculino"
                        : "Femenino"
                    }}
                  </label>
                </div>
              </div>
              <div style="display: flex; align-items: center">
                <label for="" style="">{{
                  prosecutionForm.customer_born_date + " años"
                }}</label>
              </div>
            </v-card>
          </div>
        </v-row>
        <v-row
          v-if="
            prosecutionForm.sale != null &&
              prosecutionForm.sale.doctor_id != null
          "
        >
          <div style="padding: 10px 13px; width: 100%">
            <v-card
              elevation="2"
              style="
                padding: 10px 15px;
                display: flex;
                justify-content: space-between;
                width: 100%;
              "
            >
              <div style="display: flex; flex-direction: column">
                <label for="" style="font-weight: 900">Medico</label>
                <label for="">{{ prosecutionForm.sale.doctor_fullname }}</label>
                <!-- <label for=""> {{ prosecutionForm.sale.company_name }} </label> -->
              </div>
            </v-card>
          </div>
        </v-row>

        <v-row v-if="prosecutionForm.sale != null">
          <div style="display: flex; flex-direction: column;" class=" pl-3">
            <label>Descargar Reactivos</label>
            <v-btn-toggle
              v-model="prosecutionForm.descargar_reactivos"
              :value="prosecutionForm.descargar_reactivos"
              mandatory
              dense
              color="green darken-3"
              class="float-right"
              @change="handleChangeReactivos()"
              style="margin-top: 5px;"
            >
              <v-btn value="true" class="btn-show-mode" style="height: 28px">
                SI
              </v-btn>
              <v-btn value="false" class="btn-show-mode" style="height: 28px">
                NO
              </v-btn>
            </v-btn-toggle>
          </div>
          <v-col cols="7" class="pt-3 pb-3">
            <v-menu
              v-model="menuDateInvoice"
              :close-on-content-click="false"
              :nudge-right="40"
              transition="scale-transition"
              offset-y
              min-width="320px"
            >
              <template v-slot:activator="{ on }">
                <v-text-field
                  ref="order_date"
                  :value="prosecutionForm.date"
                  label="Toma de Muestra"
                  readonly
                  clearable
                  v-on="on"
                  outlined
                  hide-details
                ></v-text-field>
              </template>
              <v-date-picker
                :value="prosecutionForm.date"
                @input="menuDateInvoice = false"
                no-title
                locale="es"
                @change="set_date_invoice"
              >
              </v-date-picker>
            </v-menu>
          </v-col>
        </v-row>

        <v-row
          v-if="prosecutionForm.sale != null"
          style="display: flex; justify-content: end; padding-right: 1.8rem"
        >
          <div style="width: 5rem;">
            <v-text-field
              label="Hora T. M."
              :value="prosecutionForm.hour"
              v-model="prosecutionForm.hour"
              type="time"
              hide-details
            />
          </div>
        </v-row>

        <v-row
          class="pl-3 pr-3"
          style="display: flex; width: 100%; justify-content: center"
        >
          <button
            class="btn-analisis btn-analisis-active btn-reactivo"
            style=""
            @click="handleShowAddMaterial()"
          >
            Agregar Material
          </button>
        </v-row>

        <div
          v-for="(item, indice) of prosecutionForm.dataMateriales"
          :key="indice"
          style="padding: 5px 5px"
        >
          <v-row>
            <div style="padding: 10px 13px; width: 100%">
              <v-card
                elevation="2"
                style="
                  padding: 10px 15px;
                  display: flex;
                  justify-content: space-between;
                  width: 100%;
                "
              >
                <div style="display: flex; flex-direction: column">
                  <label for="" style="font-weight: 900">{{
                    item.inventory.description
                  }}</label>
                  <label for=""
                    >{{ item.cantidad }} {{ item.inventory.unit_name }}</label
                  >
                </div>
                <div style="display: flex; align-items: center">
                  <v-btn
                    icon
                    small
                    dark
                    color="red"
                    @click="handleDeleteReactivo(item, indice)"
                  >
                    <v-icon size="14">far fa-times-circle</v-icon>
                  </v-btn>
                </div>
              </v-card>
            </div>
          </v-row>
        </div>
      </template>
    </div>

    <div class="mt-3 pl-3 pt-3 pr-3">
      <template>
        <v-row>
          <v-col cols="6">
            <v-btn block height="40" dark color="red" @click="handleCancel">
              <v-icon class="mr-1" size="16">far fa-times-circle</v-icon>
              Cancelar
            </v-btn>
          </v-col>
          <v-col cols="6">
            <v-btn
              v-if="action == 'create'"
              dark
              color="success"
              block
              height="40"
              @click="handleStore"
            >
              <v-icon class="mr-1" size="16">far fa-save</v-icon>
              Guardar
            </v-btn>
            <v-btn
              v-if="action == 'update'"
              dark
              color="success"
              block
              height="40"
              @click="handleUpdate"
            >
              <v-icon class="mr-1" size="16">far fa-save</v-icon>
              Actualizar
            </v-btn>
          </v-col>
        </v-row>
      </template>
    </div>
    <add-material
      ref="addMaterial"
      :devolver-data="handleAddMaterial"
    ></add-material>
    <add-reactivos
      ref="addReactivos"
      :devolver-data="handleAddReactivos"
    ></add-reactivos>
  </v-navigation-drawer>
</template>

<script>
import { mapActions, mapState } from "vuex";
import addMaterial from "./AddMaterial";
import addReactivos from "./AddReactivos.vue";

export default {
  name: "CreateUpdate",
  components: {
    addMaterial,
    addReactivos,
  },
  data() {
    return {
      drawer: false,
      titleForm: null,
      action: null,
      prosecutionForm: {
        id: null,
        numero_orden: null,
        procesamiento: null,
        description: null,
        office_id: null,
        descargar_reactivos: "false",
        dataMateriales: [],
        sale: null,
        reactivos: null,
        date: null,
        hour: null,
        customer_born_date: "",
      },
      menuDateInvoice: false,
    };
  },
  computed: {
    ...mapState("offices", ["offices"]),
    ...mapState("prosecution", ["sale"]),
    ...mapState("authentication", ["office_id"]),
  },
  methods: {
    ...mapActions("offices", ["getOffices"]),
    ...mapActions("prosecution", [
      "getSaleByOrden",
      "resetSale",
      "store",
      "update",
    ]),
    customText(item) {
      let text = item.name;
      return text;
    },
    set_date_invoice(value) {
      this.prosecutionForm.date = value;
    },
    async showForm(title, action, procesamiento = null) {
      await this.clearData();
      this.titleForm = title;
      this.action = action;
      if (procesamiento) {
        this.setBrand(procesamiento);
      }
      this.drawer = !this.drawer;
    },
    clearData() {
      this.titleForm = null;
      this.action = null;
      this.prosecutionForm.id = null;
      this.prosecutionForm.name = null;
      this.prosecutionForm.description = null;
      this.prosecutionForm.hour = null;
      this.clearErrors();
    },
    setBrand(procesamiento) {
      this.prosecutionForm.id = procesamiento.id;
      this.prosecutionForm.numero_orden = procesamiento.order_code;
      this.prosecutionForm.office_id = procesamiento.office_id;
      this.prosecutionForm.sale = {
        order_code: procesamiento.order_code,
        sale_id: procesamiento.sale_id,
        customer_id: procesamiento.customer_id,
        customer_document: procesamiento.customer_document,
        customer_fullname: procesamiento.customer_fullname,
        customer_born_date: procesamiento.customer_born_date,
        customer_gender: procesamiento.customer_gender,
        doctor_id: procesamiento.doctor_id,
        doctor_document: procesamiento.doctor_document,
        doctor_fullname: procesamiento.doctor_fullname,
        company_name: procesamiento.company_name,
        type_document_name: procesamiento.type_document_name,
      };
      this.prosecutionForm.customer_born_date = this.calcularEdad(
        procesamiento.customer_born_date
      );
      this.prosecutionForm.date = new Date(procesamiento.date_hora_muestra)
        .toISOString()
        .slice(0, 10);
      this.prosecutionForm.hour = procesamiento.hour_toma_muestra;
      const newData = [];
      procesamiento.detail.map((dt) => {
        // ! filtrar los reactivos por office_id
        if (dt.services_materials_office_id == null) {
          dt.select = true;
          newData.push(dt);
        } else {
          if (dt.services_materials_office_id == this.office_id) {
            dt.select = true;
            newData.push(dt);
          }
        }
      });
      this.prosecutionForm.reactivos = newData;
    },
    closeForm() {
      this.clearData();
      this.drawer = false;
      this.resetSale();
      this.prosecutionForm.sale = null;
    },
    handleCancel() {
      this.closeForm();
    },
    async handleStore() {
      if (this.prosecutionForm.numero_orden && this.prosecutionForm.sale) {
        let sendData = this.parseDataForSend();
        if (this.prosecutionForm.office_id)
          sendData = { ...sendData, office_id: this.prosecutionForm.office_id };
        await this.store(sendData);
        // this.closeForm();
      }
      // if (!this.existErrors()) {
      // }
    },
    async handleUpdate() {
      let sendData = this.parseDataForSend();
      sendData = { ...sendData, id: this.prosecutionForm.id };
      // console.log("formulario:::", sendData);
      await this.update(sendData);

      // if (!this.existErrors()) {
      //   await this.update(this.prosecutionForm);
      //   this.closeForm();
      // }
    },
    existErrors() {
      let hasErrors = false;

      Object.keys(this.prosecutionForm).forEach((f) => {
        if (this.$refs[f]) {
          if (!this.prosecutionForm[f]) hasErrors = true;
          this.$refs[f].validate(true);
        }
      });

      return hasErrors;
    },
    clearErrors() {
      Object.keys(this.prosecutionForm).forEach((f) => {
        if (this.$refs[f]) this.$refs[f].reset();
      });
    },
    handleShowAddMaterial() {
      this.$refs.addMaterial.showDialog();
    },
    handleAddMaterial(item) {
      const returInventory = this.prosecutionForm.dataMateriales.find(
        (dt) => dt.inventory_id == item.inventory_id
      );
      if (returInventory) {
        // ? actualiza material inventory
        const newDataMaterial = this.prosecutionForm.dataMateriales.map((dt) =>
          dt.inventory_id == item.inventory_id ? item : dt
        );
        this.prosecutionForm.dataMateriales = newDataMaterial;
      } else {
        // ? añade un nuevo material inventory
        this.prosecutionForm.dataMateriales.push({ ...item });
      }
    },
    handleDeleteReactivo(item, indice) {
      this.prosecutionForm.dataMateriales = this.prosecutionForm.dataMateriales.filter(
        (dt) => dt.inventory_id != item.inventory_id
      );
    },
    handleInputSearchByEnter(KeyboardEvent) {
      if (KeyboardEvent.code == "Enter") {
        this.handleSearch();
      }
    },
    async handleSearch() {
      let filters = {};
      if (this.prosecutionForm.numero_orden != null) {
        filters = {
          order_code: this.prosecutionForm.numero_orden,
        };

        if (this.prosecutionForm.office_id != null)
          filters = { ...filters, office_id: this.prosecutionForm.office_id };
        await this.getSaleByOrden(filters);
        if (this.sale?.sale) {
          this.prosecutionForm.sale = { ...this.sale.sale };

          this.prosecutionForm.customer_born_date = this.calcularEdad(
            this.sale?.sale.customer_born_date
          );

          if (this.sale?.reactivos) {
            const newData = [];
            this.prosecutionForm.reactivos = [...this.sale.reactivos];
            this.prosecutionForm.reactivos.map((dtr) => {
              // ! filtrar los reactivos por office_id
              if (dtr.services_materials_office_id == null) {
                dtr.select = true;
                newData.push(dtr);
              } else {
                if (dtr.services_materials_office_id == this.office_id) {
                  dtr.select = true;
                  newData.push(dtr);
                }
              }
            });
            this.prosecutionForm.reactivos = newData;
          }
        }
      }
    },
    handleChangeMaterial() {
      if (
        this.prosecutionForm.numero_orden != null &&
        this.prosecutionForm.office_id != null
      ) {
        this.handleSearch();
      }
    },
    parseDataForSend() {
      const hora = new Date().toLocaleTimeString([], { timeStyle: "short" });
      return {
        order_code: this.prosecutionForm.numero_orden,
        descargar_reactivos: this.prosecutionForm.descargar_reactivos,
        dataMateriales: this.prosecutionForm.dataMateriales,
        sale_id: this.prosecutionForm.sale?.sale_id,
        reactivos: this.prosecutionForm.reactivos,
        date: this.prosecutionForm.date
          ? this.prosecutionForm.date +
            " " +
            (this.prosecutionForm.hour == null
              ? hora
              : this.prosecutionForm.hour)
          : null,
        hour: this.prosecutionForm.hour,
      };
    },
    handleChangeReactivos() {
      if (this.prosecutionForm.descargar_reactivos == "true") {
        this.$refs.addReactivos.showDialog(this.prosecutionForm?.reactivos);
      }
    },
    handleAddReactivos(items) {
      const newDataReactivos = [];
      items.map((i) => {
        i.select = i.select == true ? true : false;
        newDataReactivos.push(i);
      });
      this.prosecutionForm.reactivos = newDataReactivos;
    },
    calcularEdad(fecha) {
      var hoy = new Date();
      var cumpleanos = new Date(fecha);
      var edad = hoy.getFullYear() - cumpleanos.getFullYear();
      var m = hoy.getMonth() - cumpleanos.getMonth();

      if (m < 0 || (m === 0 && hoy.getDate() < cumpleanos.getDate())) {
        edad--;
      }

      return edad;
    },
  },
  mounted() {
    this.getOffices();
  },
};
</script>

<style scoped>
.btn-analisis {
  border-radius: 23px;
  padding: 0.5rem 2rem;
  background-color: #eeeeee;
  color: #aaaaaa;
  font-weight: 600;
}
.btn-analisis-active {
  color: #5045e6;
}

.btn-reactivo:hover {
  background-color: #c0bcff;
}
</style>
